import {Button} from "@heroui/button";
import {ModalBody, ModalFooter, ModalHeader} from "@heroui/modal";

export function SafariDownloadDemoPopup({onClose}) {
    return (
        <>
            <ModalHeader className="flex shrink-0 flex-col gap-1 px-3 pb-2 pt-3">
                <span id="modal-title">How to find your Safari download</span>
            </ModalHeader>
            <ModalBody className="min-h-0 flex-1 overflow-hidden px-2 py-0">
                <div className="relative mx-auto h-full max-h-[640px] max-w-full aspect-[9/16] overflow-hidden rounded-xl bg-black">
                    <iframe
                        className="absolute inset-0 h-full w-full"
                        src="https://www.youtube.com/embed/o9yp3j_FXdk?start=11&autoplay=1&playsinline=1&rel=0"
                        title="How to find your downloaded video in Safari"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    />
                </div>
            </ModalBody>
            <ModalFooter className="shrink-0 px-2 pb-2 pt-2">
                <Button fullWidth color="primary" onPress={onClose}>Close</Button>
            </ModalFooter>
        </>
    );
}
